import { useState } from "react";
import { Download, Send, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const btn = "w-8 h-8 rounded-full border border-slate-300 grid place-items-center text-slate-600 hover:text-[#007A8A] hover:border-[#007A8A] transition-colors disabled:opacity-40";
const errOf = async (e, fallback) => {
  const t = e.response?.data instanceof Blob ? await e.response.data.text().catch(() => "") : "";
  try { return JSON.parse(t).detail || fallback; } catch { return e.response?.data?.detail || fallback; }
};

// Admin: download or re-email the PDF receipt for a paid enrollment / order.
export const ReceiptActions = ({ kind, row, auth }) => {
  const [busy, setBusy] = useState("");
  if (row.payment_status !== "paid") return <span className="text-xs text-slate-400">Not paid</span>;
  const download = async () => {
    setBusy("dl");
    try {
      const { data } = await api.get(`/admin/receipts/${kind}/${row.id}`, { ...auth, responseType: "blob" });
      const url = URL.createObjectURL(data);
      Object.assign(document.createElement("a"), { href: url, download: `RoboSpark-receipt-${row.id.slice(0, 8).toUpperCase()}.pdf` }).click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } catch (e) { toast.error(await errOf(e, "Could not download the receipt")); } finally { setBusy(""); }
  };
  const resend = async () => {
    setBusy("send");
    try {
      const { data } = await api.post(`/admin/receipts/${kind}/${row.id}/resend`, {}, auth);
      toast.success(`Receipt emailed to ${data.to}`);
    } catch (e) { toast.error(await errOf(e, "Could not resend the receipt")); } finally { setBusy(""); }
  };
  return (
    <div className="flex gap-1.5">
      <button type="button" onClick={download} disabled={!!busy} title="Download PDF receipt" aria-label="Download PDF receipt" className={btn} data-testid={`receipt-download-${row.id}`}>
        {busy === "dl" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}
      </button>
      <button type="button" onClick={resend} disabled={!!busy} title="Email the receipt again" aria-label="Email the receipt again" className={btn} data-testid={`receipt-resend-${row.id}`}>
        {busy === "send" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}
      </button>
    </div>
  );
};
